import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const SEARCH_HISTORY_STORAGE_KEY = "manabakh_search_history";

export const readStoredSearchHistory = () => {
  if (typeof window === "undefined") return [];

  try {
    const rawHistory = window.localStorage.getItem(SEARCH_HISTORY_STORAGE_KEY);
    const parsedHistory = JSON.parse(rawHistory || "[]");

    return Array.isArray(parsedHistory)
      ? parsedHistory.filter((item) => typeof item === "string").slice(0, 6)
      : [];
  } catch {
    return [];
  }
};

const persistSearchHistory = (history) => {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(
      SEARCH_HISTORY_STORAGE_KEY,
      JSON.stringify(history)
    );
  } catch {
    // Ignore storage failures; Redux still keeps the current session history.
  }
};

const initialState = {
  // The first client render must match the server render. Stored history is
  // restored by StoreProvider after hydration.
  searchHistory: [],
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    hydrateSearchHistory: (state, action) => {
      state.searchHistory = Array.isArray(action.payload) ? action.payload : [];
    },
    addSearchHistoryItem: (state, action) => {
      let _state = _.cloneDeep(state.searchHistory);
      let filtered = _state.filter((x) => x !== action.payload);
      filtered.push(action.payload);
      state.searchHistory = filtered.slice(0, 6);
      persistSearchHistory(state.searchHistory);
    },
    removeSearchHistoryItem: (state, action) => {
      let _state = _.cloneDeep(state.searchHistory);
      let filtered = _state.filter((x) => x !== action.payload);
      state.searchHistory = filtered;
      persistSearchHistory(state.searchHistory);
    },
    clearHistory: (state) => {
      state.searchHistory = [];
      persistSearchHistory(state.searchHistory);
    },
  },
});

export const {
  hydrateSearchHistory,
  addSearchHistoryItem,
  clearHistory,
  removeSearchHistoryItem,
} = searchSlice.actions;
export default searchSlice.reducer;
